import Component from '@ux/component';
import React from 'react';
import PropTypes from 'prop-types';

import shapes from './shapes';

class NotificationsEmpty extends Component {
  render() {
    const { failed } = this.props;

    if (failed) {
      const {
        sso,

        messages: {
          failedNotificationsTitle,
          failedNotificationsText,
          failedNotificationsLink
        }
      } = this.props;

      const classes = 'notifications-list-empty notifications-session-alert';

      return (
        <li className={ classes }>
          <strong>{ failedNotificationsTitle }</strong>
          <div>{ failedNotificationsText }</div>
          <a { ...sso.login }>{ failedNotificationsLink }</a>
        </li>
      );
    }

    const {
      messages: { noNotificationsTitle, noNotificationsText }
    } = this.props;

    const classes = 'notifications-list-empty notifications-alert';

    return (
      <li className={ classes }>
        <strong>{ noNotificationsTitle }</strong>
        <div className='no-notifications-text'>{ noNotificationsText }</div>
      </li>
    );
  }
}

NotificationsEmpty.propTypes = {
  sso: shapes.sso.isRequired,
  messages: shapes.messages.isRequired,
  failed: PropTypes.bool
};

export default NotificationsEmpty;
